module.exports = __webpack_public_path__ + "static/media/lab1.236d9707.webp";